<template>
  <v-row no-gutters>
    <v-col md="3">
      <text-field
        v-model="search"
        outlined
        clearable
        label="Search Project"
        placeholder="Type to search"
      />
    </v-col>
    <v-col md="12">
      <data-table
        :search="search"
        :disable-filtering="true"
        :items="members"
        :headers="headers"
        :custom-columns="[
          'item.member',
          'item.see_team_activity',
          'item.can_own_time_add',
          'item.can_any_time_add',
          'item.can_own_time_delete',
          'item.can_any_time_delete'
        ]"
      >
        <template v-slot:custom-render-item.member="{ item }">
          <div class="d-flex align-center">
            <div class="custom-member">
              <img
                class="custom-member-img"
                :src="item.image"
                alt=""
              >
            </div>
            {{ item.name }}
          </div>
        </template>
        <template v-slot:custom-render-item.see_team_activity="{ item }">
          <v-icon :color="item.can_see_any_activity ? 'success' : 'error'">
            {{ item.can_see_any_activity ? 'check_circle' : 'cancel' }}
          </v-icon>
        </template>
        <template v-slot:custom-render-item.can_own_time_add="{ item }">
          <v-switch
            v-model="item.can_own_time_add"
            color="success"
            hide-details
            @change="(val) => onToggle(item, 'can_own_time_add', val)"
          />
        </template>
        <template v-slot:custom-render-item.can_any_time_add="{ item }">
          <v-switch
            v-model="item.can_any_time_add"
            color="success"
            hide-details
            @change="(val) => onToggle(item, 'can_any_time_add', val)"
          />
        </template>
        <template v-slot:custom-render-item.can_own_time_delete="{ item }">
          <v-switch
            v-model="item.can_own_time_delete"
            color="success"
            hide-details
            @change="(val) => onToggle(item, 'can_own_time_delete', val)"
          />
        </template>
        <template v-slot:custom-render-item.can_any_time_delete="{ item }">
          <v-switch
            v-model="item.can_any_time_delete"
            color="success"
            hide-details
            @change="(val) => onToggle(item, 'can_any_time_delete', val)"
          />
        </template>
      </data-table>
    </v-col>
  </v-row>
</template>

<script>
import TextField from '@/components/ui/TextField/TextField';
import DataTable from '@/components/collections/DataTable/DataTable';
import { MEMBER_RIGHTS } from '@/views/Settings/constants';
import { apiCall } from '@/services/axios';
import { debounce } from '@/helpers';

export default {
  name: 'MemberRights',
  components: { DataTable, TextField },
  data() {
    return {
      search: null,
      headers: MEMBER_RIGHTS,
      members: [],
    };
  },
  computed: {
    selectedWorkspaceId() {
      return this.$store.getters.getSelectedWorkspace.id;
    },
  },
  watch: {
    selectedWorkspaceId() {
      this.fetchMembers();
    },
    search: debounce(function onSearchDebounced(searchValue) {
      this.fetchMembers({ page: 1, search: searchValue });
    }, 500),
  },
  mounted() {
    this.fetchMembers();
  },
  methods: {
    async fetchMembers(params = { page: 1, search: null }) {
      try {
        const { data } = await apiCall('get', `workspaces/${this.selectedWorkspaceId}/member-rights`, {}, {}, params);
        this.members = data;
      } catch (error) {
        console.log(error, 'error');
      }
    },
    async onToggle(item, field, value) {
      try {
        await apiCall('post', `workspaces/${this.selectedWorkspaceId}/member-rights`, {
          id: item.id,
          field,
          value: value === true ? 1 : 0,
        });
      } catch (error) {
        console.log(error, 'error');
      } finally {
        this.$store.commit('addNewSnackBar', {
          text: 'Permissions are saved!',
          status: 'success',
          show: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/sass/_variables.scss";

  .custom-member {
    display: flex;
    align-items: center;
    &-img {
      width: 28px;
      height: 28px;
      border: 2px solid $white;
      border-radius: 11px;
      margin-right: 8px;
    }
  }
  .v-input--switch {
    margin-top: 0 !important;
    &.v-input--is-label-active {
      ::v-deep.v-input--switch__thumb {
        left: 0 !important;
      }
      ::v-deep.v-input--selection-controls__ripple {
        left: -11px !important;
      }
    }
    ::v-deep.v-input--switch__thumb {
      height: 14px !important;
      width: 14px !important;
      top: calc(50% - 5px);
      background-color: $white;
      left: 5px;
    }
    ::v-deep.v-input--switch__track {
      height: 20px !important;
      width: 34px !important;
    }
  }
  ::v-deep .v-input--selection-controls__input .v-input--selection-controls__ripple {
    left: -5px !important;
    top: calc(50% - 15px) !important;
  }
</style>
